import { render, staticRenderFns } from "./RecommendationLiveSearch.vue?vue&type=template&id=73c59922&"
import script from "./RecommendationLiveSearch.vue?vue&type=script&lang=js&"
export * from "./RecommendationLiveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports